import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, ButtonGroup, CustomInput, ListGroup, ListGroupItem } from 'reactstrap';

import AuthProvider from '../../AuthProvider';
import actions from './actions';
import { TIPOS_NOTIFICACAO } from './constants';
import { Item as ExpandableItem, Detail } from '../../components/ExpandableItem';

class CadastroNotificacoes extends Component {
  constructor (props) {
    super(props);

    this.state = {
      value: props.value,
      openNotificacoes: {}
    };
  }

  componentDidMount() {
    this.props.actions.onLoadConfiguracoes();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.value !== prevProps.value) {
      this.setState({ value: this.props.value });
    }
  }

  onCheckboxBtnClick (i, j) {
    console.log(i, j);
    this.setState(({ value }) => ({
      value: {
        ...value,
        [i]: value[i]?[...value[i], j].filter(v => v !== j || -1 === value[i].indexOf(j)):[j]
      }
    }));
  }

  onSwitchClick (i, j) {
    let isActive = this.isSwitchActive(i);
    if (0 === i) {
      this.setState({
        value: (isActive?{}:TIPOS_NOTIFICACAO.reduce((s, v) => {
          s[v[0]] = j;
          return s;
        }, {}))
      });
    } else {
      this.setState({
        value: {
          ...this.state.value,
          [i]: (isActive?[]:j)
        }
      });
    }
  }

  saveNotificactions () {
    this.props.actions.onSaveConfiguracoes([]
      .concat(...Object.entries(this.state.value)
      .map(u => u[1]
        .map(v => [parseInt(u[0], 10), v]))));    
  }

  isCheckBoxActive (i, j) {
    return i in this.state.value && -1 < this.state.value[i].indexOf(j);
  }

  isSwitchActive (i) {
    return (0 === i && Object.values(this.state.value).some(v => 0 < v.length))
        || (0 < i && i in this.state.value && 0 < this.state.value[i].length);
  }

  toggleNotificacao = index => e => {
    this.setState(state => ({
      openNotificacoes: {
        ...state.openNotificacoes,
        [index]: !state.openNotificacoes[index]
      }
    }))
  };

  render () {
    const { openNotificacoes } = this.state;

    return (<div><div className="text-right"><Button disabled={2 !== this.props.fetching} color="primary" onClick={() => this.saveNotificactions()}><span className="fa fa-bell" /> Salvar</Button></div><br />
      <ListGroup>
        <ListGroupItem color="dark" className='lcr-container-row d-flex justify-content-between align-items-center'>
          <div>Todas</div>
          <CustomInput type="switch" id="exampleCustomSwitchAll" onChange={() => this.onSwitchClick(0, [2, 4])} checked={this.isSwitchActive(0)} name="customSwitch" />
        </ListGroupItem>
        <AuthProvider>
          {(_undefined, containsRole) => {
            return TIPOS_NOTIFICACAO
            .filter(u => true === u[2] || containsRole(u[2]))
            .map((u, i) => {
              const active = this.isSwitchActive(u[0]);

              return (<ExpandableItem
                isOpen={0 !== u[0] && openNotificacoes[u[0]]}
                key={i}
                tag={ListGroupItem}
                onClick={this.toggleNotificacao(u[0])}
                color={0 === u[0]?"dark":""}
                className="lcr-container-row d-flex justify-content-between align-items-center">
                <div>
                  {0 !== u[0] && <span style={{width:'10px'}} className={openNotificacoes[u[0]]?"fa fa-caret-down":"fa fa-caret-right"}></span>}{' '}
                  <span className="d-none d-sm-inline">{u[1].join(" » ")}</span>
                  <span className="d-sm-none">{u[1][0]}<br />{u[1].slice(1).join(" » ")}</span>
                </div>
                <CustomInput type="switch" id={"exampleCustomSwitch" + i} onChange={() => this.onSwitchClick(u[0], [2, 4])} checked={active} name="customSwitch" />
                <Detail>
                  <ButtonGroup>
                    {[
                      [1, "E-mail", false],
                      [2, "Push", true],
                      [3, "SMS", false],
                      [4, "Web", true]
                    ].map((v, j) => <Button key={j} outline disabled={!v[2]} onClick={() => this.onCheckboxBtnClick(u[0], v[0])} active={this.isCheckBoxActive(u[0], v[0])}>{v[1]}</Button>)}
                  </ButtonGroup>
                  {!!u[3] && <Fragment><br />* {u[3]}</Fragment>}
                </Detail>
              </ExpandableItem>);
/*               return (<Fragment key={i}>
                <ListGroupItem
                  onClick={this.toggleNotificacao(u[0])}
                  color={0 === u[0]?"dark":""}
                  className="lcr-container-row d-flex justify-content-between align-items-center">
                  <div>
                    {0 !== u[0] && <span style={{width:'10px'}} className={openNotificacoes[u[0]]?"fa fa-caret-down":"fa fa-caret-right"}></span>}{' '}
                    <span className="d-none d-sm-inline">{u[1].join(" » ")}</span>
                    <span className="d-sm-none">{u[1][0]}<br />{u[1].slice(1).join(" » ")}</span>
                  </div>
                  <CustomInput type="switch" id={"exampleCustomSwitch" + i} onChange={() => this.onSwitchClick(u[0], 2)} checked={active} name="customSwitch" />
                </ListGroupItem>
                {0 !== u[0] && openNotificacoes[u[0]] && <ListGroupItem>
                  <ButtonGroup>
                    {[
                      [1, "E-mail", false],
                      [2, "Push", true],
                      [3, "SMS", false],
                      [4, "Web", true]
                    ].map((v, j) => <Button key={j} outline disabled={!v[2]} onClick={() => this.onCheckboxBtnClick(u[0], v[0])} active={this.isCheckBoxActive(u[0], v[0])}>{v[1]}</Button>)}
                  </ButtonGroup>
                  {!!u[3] && <Fragment><br />* {u[3]}</Fragment>}
                </ListGroupItem>}
              </Fragment>);
 */            });
          }}
        </AuthProvider>
      </ListGroup>
    </div>);
  }
}

let mapStateToProps = ({ notificacao: { configuracoes } }) => ({
  fetching: configuracoes.fetching,
  value: configuracoes.result.reduce((s, v) => {
    if (!(v[0] in s)) {
      s[v[0]] = [];
    }
    s[v[0]].push(v[1]);
    return s;
  }, {})
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CadastroNotificacoes);



// WEBPACK FOOTER //
// ./src/modules/notificacao/CadastroNotificacoes.js